import { combineReducers, Reducer } from "redux";
import { IStateType } from "../models/root.interface";
import authReducer from "./auth.reducer";

const rootReducer: Reducer<IStateType> = combineReducers({
    permissions: authReducer
});

export default rootReducer;